module.exports = __webpack_public_path__ + "./fonts/themify9f24.eot";